import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextAreaForm, TextInputForm, } from 'src/components/shared/ui/form-field-elements';
import FormDialogFooter from '@/components/shared/ui/dialogs/form-dialog/FormDialogFooter';
import { Label } from '@/components/shared/ui/form-field-elements/Label';
import { ColorSelectorForm } from '@/components/shared/ui/form-field-elements/ColorSelector';
import { Separator } from '@/components/shared/ui/primitives/Separator';
import useFormDialogStore from '@/lib/zustand/form-dialog-store';
import { useNavigate } from 'react-router-dom';
import HeadlineTextInputForm from '@/components/shared/ui/form-field-elements/HeadlineTextInput';
import { useCreateClient, useDeleteClient, useEditClient, } from '@/lib/api/client-api';
import useConfirmationDialogStore from '@/lib/zustand/confirmation-dialog-store';
export const NewClientDialog = ({ formMethods }) => {
    //utility hooks
    const navigate = useNavigate();
    const { formDialogState, setFormDialogState } = useFormDialogStore();
    const setConfirmationDialogState = useConfirmationDialogStore((state) => state.setConfirmationDialogState);
    const createClient = useCreateClient();
    const editClient = useEditClient();
    const deleteClient = useDeleteClient();
    // form utilities
    const { handleSubmit } = formMethods;
    const closeDialog = () => {
        setFormDialogState((prev) => {
            return {
                ...prev,
                isOpen: false,
            };
        });
    };
    // submit handler
    const onSubmit = async (data) => {
        if (formDialogState.mode === 'create') {
            const createClientPayload = {
                name: data.name,
                themeColor: data.themeColor,
                taxId: data.taxId,
                email: data.email,
                phoneNumber: data.phoneNumber,
                address: data.address,
                detail: data.detail,
            };
            closeDialog();
            const client = await createClient.mutateAsync(createClientPayload);
            navigate(`/home/clients/${client.id}`);
        }
        else if (formDialogState.mode === 'edit') {
            const editClientPayload = {
                id: data.id,
                name: data.name,
                themeColor: data.themeColor,
                taxId: data.taxId,
                email: data.email,
                phoneNumber: data.phoneNumber,
                address: data.address,
                detail: data.detail,
            };
            closeDialog();
            await editClient.mutateAsync(editClientPayload);
            window.location.reload();
        }
    };
    const handleDestructiveButton = () => {
        if (formDialogState.mode === 'edit') {
            const deleteProjectFn = async () => {
                await deleteClient.mutateAsync(formDialogState.data.id);
                if (formDialogState.openedOn === 'clientPage') {
                    navigate(`/home/clients`);
                }
            };
            setConfirmationDialogState({
                actions: {
                    primary() {
                        deleteProjectFn();
                    },
                },
                entityName: formDialogState.data.name,
                isOpen: true,
                type: 'delete',
                additionalMessage: 'This action will also delete every files, tasks, events and notes created under this project.',
                dialogRequested: {
                    mode: 'edit',
                    type: 'clientSettings',
                },
            });
        }
        closeDialog();
    };
    return (_jsxs("form", { onSubmit: handleSubmit(onSubmit), children: [_jsxs("div", { className: "px-4 pt-3 pb-4 flex flex-col gap-2", children: [_jsx("div", { className: "leading-tight", children: _jsx(HeadlineTextInputForm, { formMethods: formMethods, fieldName: "name", className: "pt-1", placeholder: "Enter client's name", required: true, errorMessage: "Please enter client name" }) }), _jsxs("div", { className: "flex flex-col grow relative gap-1", children: [_jsx(Label, { children: "Theme Color" }), _jsx("div", { className: "relative", children: _jsx(ColorSelectorForm, { fieldName: "themeColor", formMethods: formMethods, required: true, errorMessage: "Please select a color" }) })] }), _jsx(Separator, { className: "mt-2 mb-1" }), _jsxs("div", { className: "flex flex-col gap-2 bg-foreground p-2 rounded-xl", children: [_jsxs("div", { className: "flex leading-tight gap-2", children: [_jsxs("div", { className: "flex flex-col grow", children: [_jsx(Label, { children: "Email" }), _jsx(TextInputForm, { fieldName: "email", className: "bg-transparent", formMethods: formMethods })] }), _jsxs("div", { className: "flex flex-col w-2/5", children: [_jsx(Label, { children: "Phone Number" }), _jsx(TextInputForm, { fieldName: "phoneNumber", className: "bg-transparent", formMethods: formMethods })] })] }), _jsxs("div", { className: "flex flex-col grow", children: [_jsx(Label, { children: "Tax ID" }), _jsx(TextInputForm, { fieldName: "taxId", className: "bg-transparent", formMethods: formMethods })] }), _jsxs("div", { className: "flex flex-col grow", children: [_jsx(Label, { children: "Address" }), _jsx(TextAreaForm, { fieldName: "address", className: "bg-transparent ", formMethods: formMethods })] })] })] }), _jsx(FormDialogFooter, { formMethods: formMethods, onDiscard: handleDestructiveButton, entity: "Client", customText: {
                    destructiveButton: {
                        editModeText: 'Delete Client',
                    },
                } })] }));
};
